import 'css-chunksrc/client/scenes/resourceGroupEdition/groupEditionForm/resourcesList/styles.scss';export default {
  "resourcesList": "_resourcesList_1sfyt_1",
  "title": "_title_1sfyt_9",
  "group": "_group_1sfyt_17",
  "resourceForm": "_resourceForm_1sfyt_21",
  "resources": "_resources_1sfyt_1",
  "resource": "_resource_1sfyt_1",
  "addResourceButton": "_addResourceButton_1sfyt_39",
  "marginForm": "_marginForm_1sfyt_46"
};